module.exports = "<button type=\"button\" class=\"btn btn-select-file\" (click)=\"fileInput.click()\">\r\n  {{buttonText}}\r\n  <input #fileInput\r\n         [multiple]=\"!isSingleSelect\"\r\n         (change)=\"onInputChange($event)\"\r\n         type=\"file\"\r\n         [accept]=\"acceptedFileTypes\">\r\n</button>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Biziclick/bizisystem/src/app/shared/select-file/select-file.component.html
// module id = ../../../../../src/app/shared/select-file/select-file.component.html
// module chunks = main